<!--=============================
=            INVOICE            =
==============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Invoice</div>
      </base-header>
    </v-row>
    <v-row>
     

        <v-col cols="12" md="12" sm="12">
          <base-card>
            <div slot="card-header">
                <v-row>   <v-col cols="12" sm="4">
                  <v-card class="card-light" outlined tile>
                    <v-card-text>
                      <div class="text--primary">
                        <img style="width:200px" src="../../assets/images/logo1.png">
                        <div class="text--primary pl-5 mt-8 mb-5">
                          Admin Personal Template </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-card class="card-light" outlined tile>
                    <v-card-text>
                      <div> From:</div>
                      <p class=" text--primary">
                        Webz Poland
                      </p>
                      <p>71-101 Szczecin, Poland</p>
                      <div class="text--primary">
                        Phone: +48 444 666 3333
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-card class="card-light" outlined tile>
                    <v-card-text>
                      <div> To:</div>
                      <p class=" text--primary">
                        Bob Mart
                      </p>
                      <p> Attn: Andrey</p>
                      <div class="text--primary">

                        43-190 Mikolow, Poland

                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
             
              </v-row>
            </div>
          
            <div slot="card-body">
            
              <div style="height:150px"></div> 
              <v-simple-table class="card-light transparent">
                <template v-slot:default>
                  <thead class="card-light">
                    <tr>
                      <th class="text-left">
                        Name
                      </th>
                      <th class="text-left">
                      Price
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='item in items'>
                      <td class="card-light">{{ item.title }}</td>
                      <td>{{ item.body }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div style="height:150px"></div>
              <v-divider></v-divider>
              <v-row no-gutters>
                <div style="height:80px"></div>
                <div class="my-2 d-flex text-right">
                  <v-col cols="12" sm="12" md="12">
                    <v-btn @click='generatePDF' block color="primary" dark>
                      PDF
                    </v-btn>
                  </v-col>
                </div>
              </v-row>
            </div>
          </base-card>
        </v-col>


    
    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
             heading: "Prudence Admin Personal Template",
      moreText: [
      "This is another few sentences of text to look at it.",
      "Just testing the paragraphs to see how they format.",
      "jsPDF likes arrays for sentences.",
      "Do paragraphs wrap properly?",
      "Yes, they do!",
      "What does it look like?",
      "Not bad at all."],

      items: [
      { title: "Template", body: "$45,00" },
      { title: "Job",  body: "$985,00" },
      { title: "Preview", body: "$875,00" },
      { title: "VIdeo",  body: "$455,00" }] 

      }
    },
    methods: {
    generatePDF() {
      const columns = [
      { title: "Title", dataKey: "title" },
      { title: "Body", dataKey: "body" }];

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: "letter" });

      // text is placed using x, y coordinates
      doc.setFontSize(16).text(this.heading, 0.5, 1.0);
      // create a line under heading 
      doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
      // Using autoTable plugin
      doc.autoTable({
        columns,
        body: this.items,
        margin: { left: 0.5, top: 1.25 } });

      // Using array of sentences
      doc.
      setFont("helvetica").
      setFontSize(12).
      text(this.moreText, 0.5, 3.5, { align: "left", maxWidth: "7.5" });

      // Creating footer and saving file
      doc.
      setFont("times").
      setFontSize(11).
      setFontStyle("italic").
      setTextColor(0, 0, 255).
      text(
      "TemerAvelar",
      0.5,
      doc.internal.pageSize.height - 0.5).

      save(`${this.heading}.pdf`);
    } }

  }
</script>
<style scoped>
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>


<!--====  End of INVOICE  ====-->
